import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { styles } from "assets/jss/default/views/errorPageStyles";
import { Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useTrackPageView } from "hooks/useTrackPageView";

const useStyles = makeStyles(styles);

function InvalidUserAccountConfiguration() {
  useTrackPageView("Invalid Account");
  const classes = useStyles();
  return (
    <div className={classes.contentCenter}>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <h1 className={classes.title}>403</h1>
          <h2 className={classes.subTitle}>
            You have no access to this resource.
          </h2>
          <p className={classes.description}>
            Your user account hasn&apos;t been configured to be used with AIHUB
            yet. Please contact the administrator to setup your account if you
            need access to AIHUB.
          </p>
          <div className={classes.root}>
            <Typography className={classes.margin}>
              <Link className={classes.link} to="/">
                Back to the home page.
              </Link>
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

InvalidUserAccountConfiguration.propTypes = {};

export default InvalidUserAccountConfiguration;
